const React = require('react');
const version = require('../../../../version.json');
const withState = require('../../../../utils/withState');
const {
  version$,
} = require('../../../../emitters/account');
const LayoutA = require('../../../dumb/Layout/A');
const CaptionA = require('../../../dumb/Caption/A');
const HeaderA = require('../../../dumb/Header/A');


module.exports = withState(() => {
  return (state) => {
    return (
      <LayoutA>
        <HeaderA>
          <CaptionA>Settings</CaptionA>
        </HeaderA>
        <div className="f12 tr">
          Backend: {state.version}, Frontend: {version}
        </div>
      </LayoutA>
    );
  };
}, {
  version: version$,
});
